import React from 'react';

// Design System Components
import Button from 'Components/DesignSystem/Button/Button';

// Undo icon matching Figma design (return arrow)
const UndoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M3 7h7a4 4 0 110 8H6M3 7l3-3M3 7l3 3"
    />
  </svg>
);

interface ProductReplacedIndicatorProps {
  onUndo: () => void;
}

/**
 * ProductReplacedIndicator Component
 *
 * Displays "Product Replaced" chip with Undo button after a product
 * has been replaced via Search & Replace.
 *
 * Figma: https://www.figma.com/design/pDk9UfbmLOcP5Rpr1s2OEr/Smart-Studio-2.0?node-id=11674-12496
 *
 * Design specs:
 * - Chip: Grey/600 background (#6d788c), white text, pill shape (13px radius)
 * - Border: 0.5px solid Grey/600
 * - Min-height: 28px, padding: 12px horizontal, 2px vertical
 * - Font: 14px Medium (Noto Sans)
 * - Undo Button: Blue/900 background, white icon
 */
const ProductReplacedIndicator = ({ onUndo }: ProductReplacedIndicatorProps) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
      {/* Product Replaced Chip - Grey/600 bg, white text, pill shape */}
      <span
        className="tw-inline-flex tw-items-center tw-px-3 tw-py-0.5 tw-min-h-[28px] tw-rounded-[13px] tw-bg-tone-neutral-bold tw-text-ink-inverse tw-text-sm tw-font-medium"
        style={{ border: '0.5px solid #6d788c' }}
      >
        Product Replaced
      </span>

      {/* Undo Button */}
      <Button
        variant="primary"
        onClick={onUndo}
        className="tw-w-8 tw-min-w-[32px] tw-flex tw-items-center tw-justify-center"
      >
        <UndoIcon />
      </Button>
    </div>
  );
};

export default ProductReplacedIndicator;
